<template>
  <section ref="section" :id="content.uid">
    <transition name="fade">
      <h2
        ref="logo"
        v-show="!showInfo"
        :class="{ active: active, 'bottom-logo': bottomLogo }"
        :style="{ color: content.color }"
      >
        {{ content.title }}
      </h2>
    </transition>
    <img
      v-for="(image, index) in content.images"
      :src="image.small"
      :key="index"
      data-sizes="auto"
      :data-srcset="
        image.small +
          ' 750w, ' +
          image.medium +
          ' 1280w, ' +
          image.large +
          ' 1920w, ' +
          image.hq +
          ' 2400w'
      "
      class="lazyload"
      :class="image.orientation"
    />
  </section>
</template>

<script>
export default {
  name: "Chapter",
  props: ["content", "scrollVal", "showInfo"],
  data() {
    return {
      scrollTopMax: 0,
      scrollTopMin: 0,
      active: false,
      bottomLogo: false,
    };
  },
  methods: {
    getDimensions: function() {
      this.scrollTopMin = this.$refs.section.offsetTop;
      this.scrollTopMax = this.scrollTopMin + this.$refs.section.offsetHeight;
      this.scrollLogoZone = this.scrollTopMax - this.$refs.logo.offsetHeight;
    },
    setLogo: function() {
      if (
        this.scrollVal <= this.scrollTopMax &&
        this.scrollVal >= this.scrollTopMin
      ) {
        this.active = true;
        if (this.scrollVal >= this.scrollLogoZone) {
          this.bottomLogo = true;
        } else {
          this.bottomLogo = false;
        }
      } else {
        this.active = false;
      }
    },
  },
  watch: {
    scrollVal: function() {
      this.setLogo();
      this.getDimensions();
    },
  },
  mounted() {
    const vm = this;
    setTimeout(function() {
      vm.getDimensions();
    }, 100);
  },
  created() {
    window.addEventListener("resize", this.getDimensions);
  },
};
</script>

<style lang="scss">
section img {
  opacity: 0;
  transition: opacity 400ms;
}
section img.lazyloaded {
  opacity: 1;
}

section {
  width: 100%;
  box-sizing: border-box;
  height: auto;
  position: relative;
  font-size: 11vw;
  letter-spacing: -0.015em;
  text-align: center;
  h2 {
    pointer-events: none;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-0.075em);
    z-index: 99;
    width: 100%;
    box-sizing: border-box;
    font-size: 1em;
    font-weight: 400;
  }
  h2.active {
    position: fixed;
  }
  h2.bottom-logo {
    position: absolute;
    bottom: 0;
    top: auto;
  }
  img {
    vertical-align: middle;
  }
  img.landscape {
    width: 100%;
    height: auto;
  }
  img.portrait {
    width: 50%;
    @media screen and (orientation: portrait) {
      width: 100%;
    }
    height: auto;
  }
}
</style>
